"use client";

import { Button } from "@/components/ui/Button";
import { CONSENT_OPEN_EVENT } from "@/lib/analytics/consent";

/**
 * "Change cookie preferences" control for the cookies policy page — reopens
 * the consent banner so a visitor can withdraw or grant consent at any time
 * (GDPR: withdrawing consent must be as easy as giving it).
 */
export function ManageConsent({ label }: { label: string }) {
  return (
    <Button
      variant="secondary"
      size="compact"
      onClick={() => window.dispatchEvent(new Event(CONSENT_OPEN_EVENT))}
    >
      {label}
    </Button>
  );
}
